/**
 * Hour tags preview — the country and campaign pickers (SMSWiser campaign id).
 * For Media Devoted | Created By Ciro Autiero
 */

import { useMemo } from 'react';

import { SearchableSelect } from '@/components/ui/form/input/SearchableSelect';
import { useCampaignsByCountry, useCountries } from '@/hooks/smswiser/core/useSMSWiser';

interface PreviewPickersProps {
  countryKey: string;
  wiserId: number | null;
  onCountry: (key: string) => void;
  onCampaign: (id: number) => void;
}

function useOptions(countryKey: string) {
  const { data: countries } = useCountries();
  const { data: campaigns } = useCampaignsByCountry(countryKey);
  return useMemo(
    () => ({
      countries: (countries ?? []).map((c) => ({ value: c.key, label: c.name })),
      campaigns: (campaigns ?? []).map((c) => ({ value: c.id, label: `${c.name} (#${c.id})` })),
    }),
    [countries, campaigns],
  );
}

export function PreviewPickers({ countryKey, wiserId, onCountry, onCampaign }: PreviewPickersProps) {
  const options = useOptions(countryKey);
  return (
    <div className="flex flex-col gap-2 sm:flex-row">
      <SearchableSelect
        options={options.countries}
        value={countryKey}
        onChange={onCountry}
        placeholder="Country"
        className="sm:w-56"
      />
      <SearchableSelect<number>
        options={options.campaigns}
        value={wiserId ?? 0}
        onChange={onCampaign}
        placeholder="Campaign"
        disabled={!countryKey}
        className="sm:w-80"
      />
    </div>
  );
}
